import React from 'react'

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };


  render() {
    const value = this.state.value;

    return (
      <React.Fragment>
        <div className={`${this.props.hidden && 'hidden'} relative`}>
          <input
            className={`input ${value && 'filled'} ${this.props.className}`}
            onChange={this.handleChange}
            type={this.props.type || 'text'}
            value={value || ''}
            required={this.props.required}
            style={this.props.style}
            disabled={this.props.disabled}
          />

          <div className="input-line" />

          <label className="input-label">{this.props.label}</label>
        </div>
      </React.Fragment>
    )
  }
}


export default Input;
